import { defaultGrid } from "../../helpers/datagrid";

export const showSuccessAlert = (message, header = 'Success', onConfirm = async () => { }) => async dispatch => {
	dispatch({type: 'SUCCESS_ALERT', payload: {message, onConfirm, visible: true, header} });
};

export const hideSuccessAlert = () => async dispatch => {
	dispatch({type: 'SUCCESS_ALERT', payload: {message: "", visible: false, header: ""} });
};

export const showInstallHistoryModal = (grid) => async dispatch => {
	dispatch({type: 'INSTALL_HISTORY_MODAL', payload: { grid, open: true} });
};

export const showCountDetailsModal = (data) => async dispatch => {
	dispatch({type: 'COUNT_DETAILS_MODAL', payload: { ...data, open: true} });
};

export const hideCountDetailsModal = () => async dispatch => {
	dispatch({type: 'COUNT_DETAILS_MODAL', payload: { open: false, siteDisplay: '', countDateDisplay: '' } });
};

export const hideInstallHistoryModal = () => async dispatch => {
	dispatch({type: 'INSTALL_HISTORY_MODAL', payload: { grid: { data: [], headerDef: [], rowDef: [] }, open: false} });
};

export const confirmModal = (message, visible, onConfirm, onClose = () => {}, isYesNo = false) => async dispatch => {
	dispatch({type: 'CONFIRM_MODAL', payload: {message, visible, onConfirm, onClose, isYesNo} });
};

export const showPasswordModal = (header, message, onConfirm) => async dispatch => {
	dispatch({type: 'PASSWORD_MODAL', payload: {visible: true, message, header, onConfirm} });
};

export const hidePasswordModal = () => async dispatch => {
	dispatch({type: 'PASSWORD_MODAL', payload: {visible: false, header: '', message: '', onConfirm: () => {} } });
};

export const showCollectionModal = (open, data = {}, title = "Collection Week Banking", onRefresh = () => {}, onClose = {}) => async dispatch => {
	dispatch({type: 'COLLECTION_MODAL', payload: {title, open, ...data, onRefresh, onClose } });
};

export const showBankingCommentsModal = (open, data = {}) => async dispatch => {
	dispatch({type: 'BANKING_COMMENTS_MODAL', payload: {open, ...data} });
};

export const showSiteVarianceHistoryModal = (open, data = {}) => async dispatch => {
	dispatch({type: 'SITE_VARIANCE_HISTORY_MODAL', payload: {open, ...data} });
};

export const showCollectionBreakdownModal = (data = {}, onRefresh = async () => {}, onClose = async () => { }) => async dispatch => {
	dispatch({type: 'COLLECTION_BREAKDOWN_MODAL', payload: {open: true, ...data, onRefresh, onClose} });
};

export const hideCollectionBreakdownModal = () => async dispatch => {
	dispatch({type: 'COLLECTION_BREAKDOWN_MODAL', payload: {open: false } });
}

export const showAddCommentModal = (header, subHeader, onSave = () => {}) => async dispatch => {
	dispatch({type: 'ADD_COMMENTS_MODAL', payload: {open: true, header, subHeader, onSave} });
};

export const hideAddCommentModal = () => async dispatch => {
	dispatch({type: 'ADD_COMMENTS_MODAL', payload: {open: false} });
};

export const newProfileModal = (open, data, onSave = () => {}) => async dispatch => {
	dispatch({type: 'NEW_PROFILE_MODAL', payload: {...data, open, onSave} });
};

export const showRevenueModal = (selectedSite, operator, isSiteVariance = false, onClose = () => {}, selectedVarianceType = 0) => async dispatch => {
	dispatch({type: 'REVENUE_MODAL', payload: { open: true, selectedSite, operator, isSiteVariance, onClose, selectedVarianceType } });
};

export const hideRevenueModal = () => async dispatch => {
	dispatch({type: 'REVENUE_MODAL', payload: { open: false } });
};

export const showVarianceHistoryDetailsModal = (data, onRefresh = async () => {}, onClose = async () => {}) => async dispatch => {
	dispatch({type: 'VARIANCE_HISTORY_DETAILS_MODAL', payload: { open: true, onRefresh, onClose, ...data } });
};

export const hideVarianceHistoryDetailsModal = () => async dispatch => {
	dispatch({type: 'VARIANCE_HISTORY_DETAILS_MODAL', payload: { open: false } });
};

export const showFloatLevelSettingsModal = (data) => async dispatch => {
	dispatch({type: 'FLOAT_LEVEL_SETTINGS_MODAL', payload: { open: true, ...data } });
};

export const hideFloatLevelSettingsModal = () => async dispatch => {
	dispatch({type: 'FLOAT_LEVEL_SETTINGS_MODAL', payload: { open: false } });
};

export const showLiveFloorViewDetailsModal = (installation) => async dispatch => {
	dispatch({type: 'LIVE_FLOOR_VIEW_DETAILS_MODAL', payload: { open: true, installation } });
};

export const hideLiveFloorViewDetailsModal = () => async dispatch => {
	dispatch({type: 'LIVE_FLOOR_VIEW_DETAILS_MODAL', payload: { open: false } });
};

export const showPromoAnalysisModal = (periods, selectedPeriod, grid) => async dispatch => {
	dispatch({type: 'PROMO_ANALYSIS_MODAL', payload: { periods, from: selectedPeriod, grid, open: true } });
};

export const hidePromoAnalysisModal = () => async dispatch => {
	dispatch({type: 'PROMO_ANALYSIS_MODAL', payload: { periods: [], grid: defaultGrid, open: false } });
};

export const showPromoAnalysisDetailsModal = (grid) => async dispatch => {
	dispatch({type: 'PROMO_ANALYSIS_DETAILS_MODAL', payload: { grid, open: true } });
};

export const hidePromoAnalysisDetailsModal = () => async dispatch => {
	dispatch({type: 'PROMO_ANALYSIS_DETAILS_MODAL', payload: { grid: defaultGrid, open: false } });
};

export const showSiteDetailsModal = (siteId, title, positionsFn = () => {}, eventsFn = () => {}) => async dispatch => {
	dispatch({type: 'SITE_DETAILS_MODAL', payload: { siteId, title, positionsFn, eventsFn, open: true } });
};

export const hideSiteDetailsModal = () => async dispatch => {
	dispatch({type: 'SITE_DETAILS_MODAL', payload: { open: false, positionsFn: () => {} }, eventsFn: () => {} });
};


export const showViewCommentsModal = (comments) => async dispatch => {
	dispatch({type: 'VIEW_COMMENTS_MODAL', payload: { ...comments, open: true } });
};

export const hideViewCommentsModal = () => async dispatch => {
	dispatch({type: 'VIEW_COMMENTS_MODAL', payload: { open: false } });
};